import { FollowMePlatform } from './SocialApi'

// Canonical source; keep the host-side copy in H5SocialHandler.ts in sync.
export function buildFollowMeUrl(platform: FollowMePlatform, handle: string): string {
  switch (platform) {
    case 'x':
      return `https://x.com/${handle}`
    case 'instagram':
      return `https://www.instagram.com/${handle}/`
    case 'tiktok':
      return `https://www.tiktok.com/@${handle}`
    case 'discord':
      return `https://discord.gg/${handle}`
    default: {
      const _exhaustive: never = platform
      return _exhaustive
    }
  }
}
